import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import SubNav from 'src/components/Layout/SubNav';
import useToggle from 'src/hooks/useToggle';
import { useQAContext } from 'src/containers/AddSkuPage/QuestionsFlowPage/Context';
import componentSelector from './selectors';
import { ProgressBar, TotalPriceCaret, BreakdownDropdown } from './Parts';
import styles from './styles.scss';

const SkuHeader = ({ toggleOverlay, planType, remotePossible }) => {
  const { toggleState: showBreakdown, toggle: toggleShowBreakdown } = useToggle(false);

  const toggle = useCallback(() => {
    toggleShowBreakdown();
    toggleOverlay();
  })

  const [contextState] = useQAContext();
  const breakdown = contextState.breakdown({ planType, remotePossible });

  return (
    <SubNav innerClasses={styles.innerContainer}>
      <div className={styles.skuNamePriceContainer}>
        <h5>{contextState.skuName}</h5>
        <TotalPriceCaret
          price={`$${breakdown.totalPrice}`}
          isOpen={showBreakdown}
          toggle={toggle}
        />
        <BreakdownDropdown
          breakdown={breakdown.lineItems}
          isOpen={showBreakdown}
          toggle={toggle}
        />
      </div>
      <ProgressBar percentage={`${contextState.completionPercentage}%`} />
    </SubNav>
  );
};

SkuHeader.propTypes = {
  toggleOverlay: PropTypes.func.isRequired,
  planType: PropTypes.string,
  remotePossible: PropTypes.bool.isRequired,
};

export default React.memo(
  connect(
    componentSelector,
    {},
  )(SkuHeader),
);
